/**
 * Image with fallbacks for missing user or course artwork.
 */
import React from "react";
import PropTypes from "prop-types";

import { asString } from "utils/safeData";

/**
 * Renders an image and swaps in a default asset when the source fails.
 *
 * @param {{ error?: ""|"user"|"course", src?: string, className?: string, loading?: string, decoding?: string }} props
 */
const VImage = (props) => {
  const { error, loading = "lazy", decoding = "async", ...rest } = props;
  const errorType = asString(error);

  return (
    <img
      loading={loading}
      decoding={decoding}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null;
        if (errorType === "user") currentTarget.src = `${process.env.REACT_APP_S3_ASSET_ENDPOINT}/lms/avatar.png`;
        else if (errorType === "course") currentTarget.src = `${process.env.REACT_APP_S3_ASSET_ENDPOINT}/lms/course.png`;
        else currentTarget.style.display = "none";
      }}
      {...rest}
      alt=""
    />
  );
};

VImage.defaultProps = {
  error: "", // user | course
};

VImage.propTypes = {
  error: PropTypes.oneOf(["", "user", "course"]),
  src: PropTypes.string,
  className: PropTypes.string,
};

export default VImage;
